import * as isoRandom from '@pedrouid/iso-random';
export function randomBytes(length) {
    return isoRandom.randomBytes(length);
}
//# sourceMappingURL=index.js.map